export default __webpack_public_path__ + "7fa9554f91bd2608dc37aa0d54f3d864.wav";